
// Contains what should be shown in main menu based on role and orgRole

const adminAuth = {
    resourcebooking: true,
    bookings: true,
    deals: true,
    resources: true,
    maintenance: true,
    events: true,
    persons: true,
    myAccount: true,
    users: true,
    settings: true,
    customers: true,
    eventExternal: false,
}

const cleaningstaff = {
    resourcebooking: true,
    bookings: false,
    deals: false,
    resources: false,
    maintenance: true,
    events: false,
    persons: false,
    myAccount: true,
    users: false,
    settings: false,
    customers: false,
    eventExternal: false,

    redirect: "/maintenance"

}

const janitor = {
    resourcebooking: true,
    bookings: false,
    deals: false,
    resources: false,
    maintenance: false,
    events: true,
    persons: false,
    myAccount: true,
    users: false,
    settings: false,
    customers: false,
    eventExternal: false,

    redirect: "/resourcebooking"

}
const external = {
    resourcebooking: false,
    bookings: false,
    deals: false,
    resources: false,
    maintenance: false,
    events: false,
    persons: false,
    myAccount: false,
    users: false,
    settings: false,
    customers: false,
    eventExternal: true,

    redirect: "/eventexternal"

}
const systemTech = {
    resourcebooking: false,
    bookings: true,
    deals: true,
    resources: true,
    maintenance: true,
    events: true,
    persons: true,
    myAccount: true,
    users: true,
    settings: true,
    customers: true,
    eventExternal: false,

}

export function findMenuAuth(orgRole, admin = false) {
    if (admin) {
        return adminAuth;
    }
    switch (orgRole) {
        case "cleaningstaff": return cleaningstaff;
        case "janitor": return janitor;
        case "systemTech": return systemTech;
        case "external": return external;
        default: return adminAuth;
    }

}

export function findRedirect(orgRole){
    switch (orgRole) {
        case "cleaningstaff": return cleaningstaff.redirect;
        case "janitor": return janitor.redirect;
        case "external": return external.redirect;
        default: return "";
    }
}